module.exports = __webpack_public_path__ + "user.svg?580b42f9de306d26ab2c60c03b5239ad";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user.svg
// module id = 76
// module chunks = 6